export interface SessionResp {
  balance: string;
  currency: string;
  currency_precision: number;
  currency_symbol: string;
  currency_id: number;
  session_id: string;
  token: string;
  is_demo: boolean;
  user_name: string;
  game_id: number;
}
